class QuickAdd extends HTMLElement {
  constructor() {
    super();

    const elements = {
      button: this.querySelector('button')
    };

    const variant_id = elements.button.dataset.variantId;

    const properties = JSON.parse(elements.button.dataset.properties || "{}");

    elements.button.addEventListener('click', (event) => {
      if (elements.button.classList.contains("BIS_trigger")) {
        return;
      }

      elements.button.classList.add("loading");

      addToCart(variant_id, 1, properties, (event) => {
        document.dispatchEvent(new CustomEvent("addtocart"));
        elements.button.classList.remove("loading");
      });
    });
  }
}

customElements.define('quick-add', QuickAdd);